module.exports = __webpack_public_path__ + "static/samepro-827553d057ac25d0e8dce886ee483756.png";